import { appConfig } from "src/config";
import { reroll } from "../components/PageSetRouter";
import {
  CounterOfferOutcome,
  updateCounterOffer,
  updateCounterOfferOutcome,
} from "src/utils/redux/slices/counterOffer";
import getStore from "src/utils/redux/store";
import { createForwardParams } from "src/utils/urlParams";
import { getPageSetFromPath } from "../pageSets";
import { pathIsInSubscriptionCancelContext } from "src/hooks/counterOffer";
import goto from ".";

function getActivePageSet() {
  return getPageSetFromPath(window.location.pathname, getStore().getState());
}

export default {
  authenticationRedirect() {
    const redirectUri = encodeURIComponent(window.location.href);
    window.location.href = `${appConfig.USERPORTAL_URL}sso?redirect_uri=${redirectUri}&response_type=code&client_id=buyflow`;
  },

  userPortalHomePage() {
    window.location.href = appConfig.USERPORTAL_URL;
  },

  cancelSubscription(isHM: boolean, isInTrial: boolean) {
    const params = createForwardParams();

    let nextLayer;
    if (isHM) {
      nextLayer = isInTrial ? "hm-cancel-trial" : "hm-cancel-subscription";
    } else {
      nextLayer = isInTrial ? "cancel-trial" : "cancel-subscription";
    }

    reroll(`/ps/${nextLayer}`, params, true);
  },

  async processOutcome(outcome: string) {
    // note: CounterOfferOutcome is an enum, but we can't use it in the header
    // because of a `yarn lint:pageset` failure
    if (!Object.values(CounterOfferOutcome).includes(outcome as any)) {
      throw new Error(`Invalid outcome: ${outcome}`);
    }
    getStore().dispatch(
      updateCounterOfferOutcome(outcome as CounterOfferOutcome)
    );

    const pageSet = await getActivePageSet();

    if (!pageSet || !pathIsInSubscriptionCancelContext()) {
      return this.counterOfferError("no-confirmation-page");
    }
    const confirmationPagePathname = `/subscription/${pageSet.layer}/confirmation`;
    return goto.pageSet(pageSet.id, confirmationPagePathname);
  },

  async counterOfferError(reason?: string, failedOutcome?: string) {
    if (
      failedOutcome &&
      !Object.values(CounterOfferOutcome).includes(failedOutcome as any)
    ) {
      throw new Error(`Invalid failed outcome: ${failedOutcome}`);
    }
    const params = createForwardParams();
    const { counterOffer } = getStore().getState();
    const { cancellationOffersFailed } = counterOffer;
    getStore().dispatch(
      updateCounterOffer({
        outcome: CounterOfferOutcome.ERROR,
        cancellationOffersFailed: failedOutcome
          ? [...cancellationOffersFailed, failedOutcome]
          : cancellationOffersFailed,
        error: {
          sourcePage: window.location.pathname,
          reason,
        },
      })
    );
    const pageSet = await getActivePageSet();
    const counterOfferLayer = !!pageSet && pathIsInSubscriptionCancelContext();
    const errorUrl = counterOfferLayer
      ? `/subscription/${pageSet.layer}/error`
      : "/subscription/error";
    if (!counterOfferLayer) {
      reroll(errorUrl, params, false);
      return;
    }
    goto.pageSet(pageSet.id, errorUrl);
  },

  exitCounterOffer() {
    if (!goto.nativeWebviewExit()) {
      this.userPortalHomePage();
    }
  },
};
